import { cn } from '@/lib/utils';

// A placeholder with a soft light passing across it (.cb-skeleton, App.css):
// the sweep is a layer that moves by transform, so nothing repaints the box
// and nothing beside it moves. Still under reduced motion.
function Skeleton({ className, ...props }) {
  return <div className={cn('cb-skeleton relative overflow-hidden rounded-md', className)} {...props} />;
}

export { Skeleton };
